var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18 2.44336H15C13.6739 2.44336 12.4021 2.97014 11.4645 3.90783C10.5268 4.84551 10 6.11728 10 7.44336V10.4434H7V14.4434H10V22.4434H14V14.4434H17L18 10.4434H14V7.44336C14 7.17814 14.1054 6.92379 14.2929 6.73625C14.4804 6.54872 14.7348 6.44336 15 6.44336H18V2.44336Z","stroke":"#333333","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Facebook.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
